'use client';

import { useState, useEffect } from 'react';

interface ProgressIndicatorProps {
  className?: string;
}

const ProgressIndicator = ({ className = '' }: ProgressIndicatorProps) => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const sections = [
    { id: 'acasa', label: 'Acasă' },
    { id: 'cine-suntem', label: 'Cine Suntem' },
    { id: 'servicii', label: 'Servicii' },
    { id: 'Estimare', label: 'Calculator' },
    { id: 'proces', label: 'Proces' },
    { id: 'proiecte', label: 'Proiecte' },
    { id: 'contact', label: 'Contact' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      const scrollPercentage = (scrollTop / (documentHeight - windowHeight)) * 100;
      setProgress(Math.min(scrollPercentage, 100));
      
      setIsVisible(scrollTop > 100);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div data-component-id="src/components/common/ProgressIndicator.tsx:44:4" data-component-path="src/components/common/ProgressIndicator.tsx" data-component-line="44" data-component-end-line="81" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`fixed top-20 left-0 right-0 z-[999] bg-card shadow-sm ${className}`}>
      <div data-component-id="src/components/common/ProgressIndicator.tsx:45:6" data-component-path="src/components/common/ProgressIndicator.tsx" data-component-line="45" data-component-end-line="50" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20h-1%20bg-surface%22%7D" className="relative h-1 bg-surface">
        <div data-component-id="src/components/common/ProgressIndicator.tsx:46:8" data-component-path="src/components/common/ProgressIndicator.tsx" data-component-line="46" data-component-end-line="49" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20top-0%20left-0%20h-full%20bg-gradient-to-r%20from-primary%20to-secondary%20transition-all%20duration-300%20ease-out%22%7D" 
          className="absolute top-0 left-0 h-full bg-gradient-to-r from-primary to-secondary transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      
      <div data-component-id="src/components/common/ProgressIndicator.tsx:52:6" data-component-path="src/components/common/ProgressIndicator.tsx" data-component-line="52" data-component-end-line="80" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20md%3Aflex%20items-center%20justify-center%20gap-2%20py-2%20px-6%20max-w-%5B1400px%5D%20mx-auto%22%7D" className="hidden md:flex items-center justify-center gap-2 py-2 px-6 max-w-[1400px] mx-auto">
        {sections.map((section, index) => {
          const sectionProgress = ((index + 1) / sections.length) * 100;
          const isCompleted = progress >= sectionProgress;
          const isActive = progress >= (index / sections.length) * 100 && progress < sectionProgress;
          
          return (
            <div data-component-id="src/components/common/ProgressIndicator.tsx:59:12" data-component-path="src/components/common/ProgressIndicator.tsx" data-component-line="59" data-component-end-line="77" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-2%22%7D" key={section.id} className="flex items-center gap-2">
              <div data-component-id="src/components/common/ProgressIndicator.tsx:60:14" data-component-path="src/components/common/ProgressIndicator.tsx" data-component-line="60" data-component-end-line="73" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-1.5%22%7D" className="flex items-center gap-1.5">
                <div data-component-id="src/components/common/ProgressIndicator.tsx:61:16" data-component-path="src/components/common/ProgressIndicator.tsx" data-component-line="61" data-component-end-line="65" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" 
                  className={`w-2 h-2 rounded-full transition-colors duration-base ${
                    isCompleted ? 'bg-success' : isActive ? 'bg-secondary' : 'bg-border'
                  }`}
                />
                <span data-component-id="src/components/common/ProgressIndicator.tsx:66:16" data-component-path="src/components/common/ProgressIndicator.tsx" data-component-line="66" data-component-end-line="72" data-component-file="ProgressIndicator.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" 
                  className={`text-xs font-body font-medium transition-colors duration-base ${
                    isCompleted || isActive ? 'text-foreground' : 'text-muted-foreground'
                  }`}
                >
                  {section.label}
                </span>
              </div>
              {index < sections.length - 1 && (
                <div data-component-id="src/components/common/ProgressIndicator.tsx:75:16" data-component-path="src/components/common/ProgressIndicator.tsx" data-component-line="75" data-component-end-line="75" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-4%20h-px%20bg-border%22%7D" className="w-4 h-px bg-border" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressIndicator;